import { Component } from '@verndale/core'
import { focusableElements } from '../utils'

const maxHeight = 250
const fadeHeight = 120

class ContentRow extends Component {
  setupDefaults() {
    this.dom = {
      copy: this.el.querySelector('.content-row-copy'),
      link: this.el.querySelector('.content-row-cta'),
      videoPlaceholder: this.el.querySelector('.content-row-image--video'),
      expandableCopy: this.el.dataset.expandableCopy
    }
    if (this.dom.videoPlaceholder) {
      this.setupVideoObserver();
      this.dom.videoPlaceholder.addEventListener('click', () => {
        const moduleId = this.dom.videoPlaceholder.id.replace('video-placeholder-', '');
        this.loadVideo(moduleId);
      });
    }
    this.focusableElements = this.dom.copy.querySelectorAll(focusableElements)
    this.isExpanded = false
    this.makeCopyExpandable()
  }
  setupVideoObserver() {
    if (!this.dom.videoPlaceholder) {
      console.warn('No video placeholder found.');
      return;
    }
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const moduleId = entry.target.id.replace('video-placeholder-', '');
          if (moduleId) {
            this.loadVideo(moduleId);
          } else {
            console.error('Module ID not found for video element:', entry.target);
          }
          observer.unobserve(entry.target);
        }
      });
    }, { root: null, rootMargin: '0px', threshold: 0.1 });

    observer.observe(this.dom.videoPlaceholder);
  }

  loadVideo(moduleId){
    const placeholder = document.getElementById(`video-placeholder-${  moduleId}`);
    if (!placeholder) {
      console.error('Placeholder not found for moduleId:', moduleId);
      return;
    }
    const videoId = placeholder.getAttribute('data-video-id');
    const videoSource = placeholder.getAttribute('data-video-source');
    // adding a condition to check the videoId and videoSource
    if (!videoId || !videoSource) {
      console.error('Missing videoId or videoSource for moduleId:', moduleId);
      return;
    }
    const iframe = document.createElement('iframe');
    let src = '';
    // Set the iframe source based on the video source
    if (videoSource === 'youtube') {
      src = `//www.youtube.com/embed/${  videoId  }?rel=0`;
    } else {
      src = `//players.brightcove.net/1547387903001/zf9qLy17UG_default/index.html?videoId=${  videoId}`;
    }
    // Set iframe attributes
    iframe.setAttribute('src', src);
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('webkitallowfullscreen', 'true');
    iframe.setAttribute('mozallowfullscreen', 'true');
    iframe.setAttribute('title', 'video');
    iframe.setAttribute('loading', 'lazy');
    iframe.style.height = '100%';
    iframe.style.width = '100%';
    // Clear the placeholder content and append the iframe
    placeholder.innerHTML = '';
    placeholder.appendChild(iframe);
  }
  makeCopyExpandable() {
    if (this.dom.expandableCopy === 'true') {
      const parentDiv = this.dom.copy.parentElement
      this.readMoreButton = document.createElement('button')
      this.readMoreButton.classList.add('content-row-expandable-button')
      this.readMoreButton.innerText = this.el.dataset.readMoreLabel
      if (
        this.dom.link &&
        !this.dom.link.previousElementSibling.classList.contains('content-row-info__inner')
      ) {
        parentDiv.insertBefore(this.readMoreButton, this.dom.link)
      } else {
        parentDiv.append(this.readMoreButton)
      }
      this.calculateTabIndex()
      this.readMoreButton.addEventListener('click', this.handleReadMore.bind(this))
      this.dom.copy.classList.add('content-row-expandable-copy')
    }
  }

  handleReadMore() {
    if (!this.isExpanded) {
      this.isExpanded = true
      this.dom.copy.classList.remove('content-row-expandable-copy')
      this.readMoreButton.textContent = this.el.dataset.readLessLabel
      this.focusableElements.forEach((element) => (element.tabIndex = 0))
    } else {
      this.isExpanded = false
      this.dom.copy.classList.add('content-row-expandable-copy')
      this.readMoreButton.textContent = this.el.dataset.readMoreLabel
      this.calculateTabIndex()
    }
  }

  calculateTabIndex() {
    this.focusableElements.forEach((element) => {
      const containerTop = this.dom.copy.getBoundingClientRect().top
      const elementTop = element.getBoundingClientRect().top

      element.tabIndex = elementTop - containerTop > maxHeight - fadeHeight ? -1 : 0
    })
  }
}

export default ContentRow
